module.exports = {
  LOGIC_HOOK_INCLUDE: 'INCLUDE'
}
